import { Box, Flex, IconButton, Text, useColorModeValue, useBreakpointValue } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  FiHome,
  FiGrid,
  FiUpload,
  FiClock,
  FiUser
} from 'react-icons/fi';
import IconWrapper from './IconWrapper';

const Navigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const activeColor = useColorModeValue('purple.600', 'purple.400');
  const inactiveColor = useColorModeValue('gray.600', 'gray.400');
  const hoverColor = useColorModeValue('purple.500', 'purple.300');

  // Mobile-first navigation with 5 main items
  const navItems = [
    { icon: FiHome, label: 'Home', path: '/' },
    { icon: FiGrid, label: 'Dashboard', path: '/creator-dashboard' },
    { icon: FiUpload, label: 'Upload', path: '/upload' },
    { icon: FiClock, label: 'Watchlist', path: '/watchlist' },
    { icon: FiUser, label: 'Profile', path: '/profile' },
  ];

  const isMobile = useBreakpointValue({ base: true, md: false });
  const iconSize = useBreakpointValue({ base: 18, sm: 20 });

  if (!isMobile) {
    return null; // Hide navigation on desktop
  }

  return (
    <Box 
      bg={navBg} 
      borderTop="1px" 
      borderColor={borderColor} 
      px={2} 
      py={2} 
      boxShadow="lg" 
      w="100%" 
      position="fixed" 
      bottom={0} 
      zIndex={10}
      borderRadius="16px 16px 0 0"
    >
      <Flex justify="space-around" w="100%" maxW="400px" mx="auto">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Flex
              key={item.path}
              direction="column"
              align="center"
              cursor="pointer"
              onClick={() => navigate(item.path)}
              px={{ base: 1, sm: 2 }}
              py={1}
              color={isActive ? activeColor : inactiveColor}
              _hover={{ color: hoverColor }}
              transition="all 0.2s"
            >
              <IconButton
                aria-label={item.label}
                icon={<IconWrapper icon={item.icon} size={iconSize} />}
                variant="ghost"
                size="sm"
                color={isActive ? activeColor : inactiveColor}
                _hover={{ bg: 'transparent', color: hoverColor }}
                bg={isActive ? 'purple.50' : 'transparent'}
                borderRadius="full"
              />
              <Text fontSize={{ base: '2xs', sm: 'xs' }} mt={1} fontWeight={isActive ? 'semibold' : 'normal'}>
                {item.label}
              </Text>
            </Flex>
          );
        })}
      </Flex>
    </Box>
  );
};

export default Navigation;